import React, { useState } from "react";
import {
  Text,
  Spacer,
  List,
  TextInline,
  Subtitle,
} from "../dynamic.components";
import SubHotspots from "../Sub-hotspots";

export const InstalSwitchSub = () => (
  <>
    <Subtitle subtitle="Install Switch" />
    <Text text="The install switch is used to toggle between flow kit installation, integrity testing, and run modes. The  flow kit install mode opens and locks the valves to enable safe operator interaction when installing the flow kit." />
    <Text text="The integrity test mode allows you to perform an air integrity test of the filter using an external air integrity tester" />
    <Text text="Run mode is used for all methods including calibration, installation tests and filtration processes. Software will start only when RUN is selected." />
    <Spacer />
  </>
);
export const StystemStatusSub = () => (
  <>
    <Subtitle subtitle="System Indicator" />
    <Text text="You can see the system status from the status panel lights." />
    <TextInline text="The " />
    <TextInline fontStyle="italic" text="pause/continue " />
    <TextInline text="button on the status panel of instrument will toggle between pause and run. It corresponds to the" />
    <TextInline fontStyle="italic" text=" pause" />
    <TextInline text=" and" />
    <TextInline fontStyle="italic" text=" continue" />
    <TextInline text=" buttons in UNICORN™ software." />
    <Spacer />
  </>
);
export const EmergencyStopSub = () => (
  <>
    <Subtitle subtitle="Emergency Stop" />
    <Text text="The emergency button is easily accessed which shuts down the system operation immediately when pushed." />
    <Spacer />
  </>
);

export const SystemStatus: React.FC = () => {
  return (
    <>
      <div className="c-sidebar__body">
        <SubHotspots sublinkId="1-2" />
      </div>
    </>
  );
};
